import { call, put, all, takeEvery } from 'redux-saga/effects'

import {
  GET_CHANGE_HISTORY,
  getChangeHistorySuccess,
  getChangeHistoryFailure,
  GET_SELECTORS,
  getSelectorsSuccess,
  getSelectorsFailure,
  UPDATE_SELECTOR,
  updateSelectorSuccess,
  updateSelectorFailure,
  getAiMessageSuccess,
  getAiMessageFailure,
  GET_AI_MESSAGE,
  CANCEL_GET_AI_MESSAGE,
  GET_AI_CONVERSATIONS,
  getAiConversationsSuccess,
  getAiConversationsFailure,
  UPDATE_AI_CONVERSATION,
  updateAiConversationSuccess,
  updateAiConversationFailure,
  getAiConversationMessagesSuccess,
  getAiConversationMessagesFailure,
  GET_AI_CONVERSATION_MESSAGES,
  getSponsorFormIndustrySuggestionsSuccess,
  getSponsorFormIndustrySuggestionsFailure,
  GET_SPONSOR_FORM_INDUSTRY_SUGGESTIONS,
  CANCEL_GET_SPONSOR_FORM_INDUSTRY_SUGGESTIONS
} from '../actions/tools'

import {
  getAiConversationMessagesService,
  getAiConversationsService,
  getAiMessageService,
  getChangeHistoryService,
  getSelectorsService,
  getSponsorFormIndustrySuggestionsService,
  updateAiConversationService,
  updateSelectorService
} from '../services/tools'
import { handleWebSocketRequest } from '../../helpers/modules/saga'

function* toolsWatcher() {
  yield all([
    // PLOP_APPEND_PATTERN_ANCHOR_WATCHER
    takeEvery(GET_CHANGE_HISTORY, getChangeHistoryWorker),
    takeEvery(GET_SELECTORS, getSelectorsWorker),
    takeEvery(UPDATE_SELECTOR, updateSelectorWorker),
    takeEvery(GET_AI_MESSAGE, getAiMessageWorker),
    takeEvery(GET_AI_CONVERSATIONS, getAiConversationsWorker),
    takeEvery(UPDATE_AI_CONVERSATION, updateAiConversationWorker),
    takeEvery(GET_AI_CONVERSATION_MESSAGES, getAiConversationMessagesWorker),
    takeEvery(GET_SPONSOR_FORM_INDUSTRY_SUGGESTIONS, getSponsorFormIndustrySuggestionsWorker)
  ])
}

// PLOP_APPEND_PATTERN_ANCHOR_WORKER

function* getAiMessageWorker({ params, requestId }) {
  yield call(handleWebSocketRequest, {
    service: getAiMessageService,
    serviceProps: {
      params,
      requestId
    },
    cancelActionType: CANCEL_GET_AI_MESSAGE,
    successAction: response => getAiMessageSuccess(response, requestId),
    failureAction: error => {
      return getAiMessageFailure(
        "Sorry, looks like the AI is having a bad day. Please regenerate if you're not happy with what has been generated",
        requestId
      )
    }
  })
}

function* getAiConversationsWorker({ params }) {
  try {
    const response = yield call(getAiConversationsService, params)
    yield put(getAiConversationsSuccess(response))
  } catch (error) {
    yield put(getAiConversationsFailure(error))
  }
}

function* getAiConversationMessagesWorker({ params }) {
  const conversationId = params.id

  try {
    const response = yield call(getAiConversationMessagesService, params)
    yield put(getAiConversationMessagesSuccess(response, conversationId))
  } catch (error) {
    yield put(getAiConversationMessagesFailure(error, conversationId))
  }
}

function* getSponsorFormIndustrySuggestionsWorker({ params, requestId }) {
  yield call(handleWebSocketRequest, {
    service: getSponsorFormIndustrySuggestionsService,
    serviceProps: {
      params,
      requestId
    },
    cancelActionType: CANCEL_GET_SPONSOR_FORM_INDUSTRY_SUGGESTIONS,
    successAction: response => getSponsorFormIndustrySuggestionsSuccess(response, requestId),
    failureAction: error => {
      return getSponsorFormIndustrySuggestionsFailure(
        "Sorry, looks like the AI is having a bad day. Please regenerate if you're not happy with what has been generated",
        requestId
      )
    }
  })
}

function* getChangeHistoryWorker({ params }) {
  try {
    const response = yield call(getChangeHistoryService, params)
    yield put(getChangeHistorySuccess(response))
  } catch (error) {
    yield put(getChangeHistoryFailure(error))
  }
}

function* getSelectorsWorker({ params }) {
  try {
    const response = yield call(getSelectorsService, params)
    yield put(getSelectorsSuccess(response))
  } catch (e) {
    yield put(getSelectorsFailure(e))
  }
}

function* updateSelectorWorker({ params }) {
  try {
    const response = yield call(updateSelectorService, params)
    yield put(updateSelectorSuccess(response))
  } catch (e) {
    yield put(updateSelectorFailure(e))
  }
}

function* updateAiConversationWorker({ id, data }) {
  try {
    const response = yield call(updateAiConversationService, id, data)
    yield put(updateAiConversationSuccess(id, response))
  } catch (error) {
    yield put(updateAiConversationFailure(id, error))
  }
}

export default toolsWatcher
